<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Auth from 'dashboard/api/auth';

const { t } = useI18n();
const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');

const message = computed(() => {
  if (isOnChatwootCloud.value) {
    return t('APP_GLOBAL.NO_ACCOUNTS.MESSAGE_CLOUD');
  }
  return t('APP_GLOBAL.NO_ACCOUNTS.MESSAGE_SELF_HOSTED');
});

const handleLogout = () => {
  Auth.logout();
};
</script>

<template>
  <div class="flex flex-col flex-1 w-full h-full bg-n-slate-2">
    <EmptyStateLayout
      :title="$t('APP_GLOBAL.NO_ACCOUNTS.TITLE')"
      :subtitle="message"
      :show-backdrop="false"
    >
      <template #actions>
        <NextButton
          variant="smooth"
          color-scheme="secondary"
          :label="$t('APP_GLOBAL.NO_ACCOUNTS.LOGOUT')"
          @click="handleLogout"
        />
      </template>
    </EmptyStateLayout>
  </div>
</template>
